export const abTestConfig = [
  {
    // no person selection, only products count!
    // v1: original, v2: no people anywhere
    scope: 'noMansSki',
    analyticsId: 'noMansSki',
    versions: ['v1', 'v2'],
    startDate: '2024-09-15',
    endDate: '2024-03-30'
  },
  {
    // additional help to find the perfect ski for you
    // v1 original
    // v2 button with skifinder bot iframe addition
    // v3 button with simple slider form to find perfect ski
    // v4 additional help on every ski like "63% with intermediate skills were satisfied with this category"
    scope: 'skifinder',
    analyticsId: 'skifinder',
    versions: ['v1', 'v2', 'v3', 'v4', 'v5'],
    startDate: '2025-01-30',
    endDate: '2025-04-30'
  },
  {
    // links on shop pile navigate to PS (v2) or PS with open Shop Info (v3) on links
    scope: 'shopNavToPS',
    analyticsId: 'shopNavToPS',
    versions: ['v1', 'v2', 'v3'],
    startDate: '2025-09-01',
    endDate: '2025-12-31'
  },
  {
    scope: 'fullscreenDatePicker',
    analyticsId: 'fullscreenDatePicker',
    versions: ['v1', 'v2'],
    startDate: '2025-09-01',
    endDate: '2025-12-31'
  },
  {
    // find out if people like help to copy data from other tabs
    scope: 'PsButler',
    versions: ['v1', 'v2'],
    analyticsId: 'AhoAihLkRWS7DyZUNXESsQ',
    startDate: '2024-09-15',
    endDate: '2024-09-16'
  },
  {
    // persons on the left and right side on PS are sticky (v2) or not (v1)
    scope: 'stickyPersonSettings',
    versions: ['v1', 'v2'],
    analyticsId: 'nUF8xqyXSNqb6bgUYebVWQ',
    startDate: '2025-01-24',
    endDate: '2025-04-30'
  },
  {
    // if binding settings should be displayed by default (v1) or collapsed (v2)
    scope: 'bindingAdjust',
    analyticsId: 'bindingAdjust',
    versions: ['v1', 'v2'],
    startDate: '2023-10-07',
    endDate: '2024-04-01'
  },
  {
    // position of a payment component on a checkout page
    // v1 - original - at bottom
    // v2 - in the same section with the personal details
    // v3 - in the same section with the personal details + this section is moved to the bottom of the page, under upselling
    scope: 'paymentPosition',
    analyticsId: 'paymentPosition',
    versions: ['v1', 'v2', 'v3'],
    startDate: '2025-09-01',
    endDate: '2025-12-31'
  }
];
